import * as React from 'react';
import NavItem from '../../../../nav/topNav/NavItem';
import {
    ANALYSTS, DATA, ENTERPRISE, LEADERSHIP, TARGET, TECHNIQUES,
    TECHNOLOGY
} from '../../../../../store/constants';
import './DeltaNav.css';

interface Props {
    activePanel: string;
}

class DeltaNav extends React.Component<Props> {
    render() {
        const { activePanel } = this.props;
        const noop = () => null;

        return (
            <nav>
                <ul className="nav-items nav-flex-container delta-nav">
                    <NavItem
                        onClick={noop}
                        activeId={activePanel}
                        id={DATA}
                        disabled={true}
                        title="Data"
                    />
                    <NavItem
                        onClick={noop}
                        activeId={activePanel}
                        id={ENTERPRISE}
                        disabled={true}
                        title="Enterprise"
                    />
                    <NavItem
                        onClick={noop}
                        activeId={activePanel}
                        id={LEADERSHIP}
                        disabled={true}
                        title="Leadership"
                    />
                    <NavItem
                        onClick={noop}
                        activeId={activePanel}
                        id={TARGET}
                        disabled={true}
                        title="Targets"
                    />
                    <NavItem
                        onClick={noop}
                        activeId={activePanel}
                        id={ANALYSTS}
                        disabled={true}
                        title="Analysts"
                    />
                    <NavItem
                        onClick={noop}
                        activeId={activePanel}
                        id={TECHNOLOGY}
                        disabled={true}
                        title="Technology"
                    />
                    <NavItem
                        onClick={noop}
                        activeId={activePanel}
                        id={TECHNIQUES}
                        disabled={true}
                        title="Techniques"
                    />
                </ul>
            </nav>
        );
    }
}

export default DeltaNav;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/component/main/content/delta/nav/DeltaNav.tsx